export default "__VITE_ASSET__CB1ZGa8s__"